/* Japonisme Museum — shared behaviour (header, reveals, compare slider,
   hero scroll scrub, starfield, cursor preview, in-page filters).
   Plain ES5-safe JS, no dependencies. Every feature is opt-in by markup. */
(function () {
  "use strict";
  var doc = document.documentElement;
  doc.classList.add("jm-js");
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------ header */
  function initHeader() {
    var hdr = document.querySelector("[data-jm-header]");
    if (!hdr || hdr.getAttribute("data-ready")) return;
    hdr.setAttribute("data-ready", "1");
    var triggers = $$("[data-jm-mega]", hdr);
    var dim = hdr.querySelector(".jm-dim");
    var drawerBtn = hdr.querySelector("[data-jm-drawer]");
    var drawer = hdr.querySelector(".jm-drawer");
    var openKey = null, closeTimer = null;

    function panel(key) { return hdr.querySelector('[data-jm-panel="' + key + '"]'); }
    function setMega(key) {
      clearTimeout(closeTimer);
      openKey = key;
      triggers.forEach(function (t) {
        var on = t.getAttribute("data-jm-mega") === key;
        t.setAttribute("aria-expanded", on ? "true" : "false");
        var p = panel(t.getAttribute("data-jm-mega"));
        if (p) p.classList.toggle("is-open", on);
      });
      if (dim) dim.classList.toggle("is-on", !!key);
      hdr.classList.toggle("is-open", !!key);
    }
    function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(function () { setMega(null); }, 200); }

    triggers.forEach(function (t) {
      var key = t.getAttribute("data-jm-mega");
      t.addEventListener("click", function () { setMega(openKey === key ? null : key); });
      t.addEventListener("mouseenter", function () { if (window.matchMedia("(hover: hover)").matches) setMega(key); });
      var p = panel(key);
      if (p) {
        p.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
        p.addEventListener("mouseleave", scheduleClose);
      }
    });
    var bar = hdr.querySelector(".jm-hdr__bar");
    if (bar) bar.addEventListener("mouseleave", function () { if (openKey) scheduleClose(); });
    if (dim) dim.addEventListener("click", function () { setMega(null); });

    function setDrawer(open) {
      hdr.classList.toggle("is-drawer", open);
      if (drawerBtn) drawerBtn.setAttribute("aria-expanded", open ? "true" : "false");
      if (drawer) drawer.setAttribute("aria-hidden", open ? "false" : "true");
      document.body.style.overflow = open ? "hidden" : "";
      if (open && drawer) { var f = drawer.querySelector("a, button"); if (f) setTimeout(function () { f.focus(); }, 300); }
    }
    if (drawerBtn) drawerBtn.addEventListener("click", function () { setDrawer(!hdr.classList.contains("is-drawer")); });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (openKey) { var t = hdr.querySelector('[data-jm-mega="' + openKey + '"]'); setMega(null); if (t) t.focus(); }
      if (hdr.classList.contains("is-drawer")) { setDrawer(false); if (drawerBtn) drawerBtn.focus(); }
    });
    document.addEventListener("focusin", function (e) { if (openKey && !hdr.contains(e.target)) setMega(null); });

    var onScroll = function () { hdr.classList.toggle("is-scrolled", window.scrollY > 8); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------ reveals */
  function initReveals() {
    var els = $$("[data-jm-reveal]:not(.is-in), .jm-split:not(.is-in), [data-jm-inview]:not(.is-in)");
    if (!els.length) return;
    if (reduced || !("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.18, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* split headlines into lines by <br> already authored as .jm-line spans; number them */
  function initSplit() {
    $$(".jm-split").forEach(function (el) {
      $$(".jm-line", el).forEach(function (l, i) { l.style.setProperty("--l", i); });
    });
  }

  /* ------------------------------------------------------------ compare slider */
  function initCompare() {
    $$("[data-jm-compare]").forEach(function (box) {
      if (box.getAttribute("data-ready")) return;
      box.setAttribute("data-ready", "1");
      var input = box.querySelector("input[type=range]");
      if (!input) return;
      var set = function (v) { box.style.setProperty("--pos", v + "%"); };
      input.addEventListener("input", function () { set(input.value); box.classList.add("is-touched"); });
      set(input.value);
      // gentle intro sweep when the slider first enters view
      if (!reduced && "IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          var start = null, from = 50;
          var step = function (ts) {
            if (box.classList.contains("is-touched")) return;
            if (!start) start = ts;
            var k = Math.min(1, (ts - start) / 2200);
            var v = from + Math.sin(k * Math.PI * 2) * 28 * (1 - k);
            set(v.toFixed(2)); input.value = v;
            if (k < 1) requestAnimationFrame(step); else { set(50); input.value = 50; }
          };
          requestAnimationFrame(step);
        }, { threshold: 0.5 });
        io.observe(box);
      }
    });
  }

  /* ------------------------------------------------------------ scroll-linked: hero scrub, parallax, year fill */
  function initScroll() {
    var scenes = $$("[data-scene]");
    var para = reduced ? [] : $$("[data-jm-parallax]");
    var fills = $$("[data-jm-fill]");
    if (!scenes.length && !para.length && !fills.length) return;
    var finalLayer = document.getElementById("layer-couple2");
    var finalLinks = finalLayer ? $$(".west-cta a", finalLayer) : [];
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      scenes.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var total = s.offsetHeight - vh;
        if (total <= 0) return;
        var p = Math.min(1, Math.max(0, -r.top / total));
        s.style.setProperty("--p", p.toFixed(4));
        if (finalLayer && s.contains(finalLayer)) {
          var active = p > 0.92;
          finalLayer.classList.toggle("is-active", active);
          finalLinks.forEach(function (a) { a.tabIndex = active ? 0 : -1; });
        }
      });
      para.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute("data-jm-parallax")) || 0.1;
        var c = (r.top + r.height / 2 - vh / 2);
        el.style.transform = "translate3d(0," + (-c * speed).toFixed(1) + "px,0)";
      });
      fills.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var k = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.9)));
        el.style.setProperty("--fill", (k * 100).toFixed(1) + "%");
      });
    }
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();
  }

  /* ------------------------------------------------------------ starfield */
  function initStars() {
    var canvas = document.getElementById("jm-stars");
    if (!canvas || canvas.getAttribute("data-ready")) return;
    canvas.setAttribute("data-ready", "1");
    var ctx = canvas.getContext("2d"), stars = [], dpr = Math.min(window.devicePixelRatio || 1, 2), visible = true;
    function seed() {
      canvas.width = canvas.clientWidth * dpr; canvas.height = canvas.clientHeight * dpr; stars = [];
      var n = Math.floor((canvas.width * canvas.height) / (9000 * dpr));
      for (var i = 0; i < n; i++) stars.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, r: (Math.random() * 1.4 + .3) * dpr, tw: Math.random() * 6.28, sp: .4 + Math.random() * 1.2 });
    }
    function draw(t) {
      if (visible) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < stars.length; i++) {
          var s = stars[i];
          ctx.globalAlpha = reduced ? .8 : .45 + .55 * Math.abs(Math.sin(s.tw + t * .001 * s.sp));
          ctx.fillStyle = "#FFF6D8"; ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.2832); ctx.fill();
        }
      }
      if (!reduced) requestAnimationFrame(draw);
    }
    seed(); window.addEventListener("resize", seed);
    if ("IntersectionObserver" in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(canvas);
    if (reduced) draw(0); else requestAnimationFrame(draw);
  }

  /* ------------------------------------------------------------ count up */
  function initCount() {
    $$("[data-jm-count]").forEach(function (el) {
      var target = parseInt(el.getAttribute("data-jm-count"), 10);
      if (isNaN(target) || reduced || !("IntersectionObserver" in window)) return;
      el.textContent = "0";
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var start = null;
        var step = function (ts) { if (!start) start = ts; var k = Math.min(1, (ts - start) / 1600); var e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(target * e); if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      }, { threshold: .6 });
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------ cursor-follow preview (types list) */
  function initFollow() {
    var list = document.querySelector("[data-jm-follow]");
    if (!list || !window.matchMedia("(hover: hover) and (min-width: 761px)").matches) return;
    var box = document.createElement("div");
    box.className = "jm-follow"; box.setAttribute("aria-hidden", "true");
    var img = document.createElement("img"); img.alt = ""; box.appendChild(img);
    document.body.appendChild(box);
    var x = 0, y = 0, cx = 0, cy = 0, raf = null;
    function loop() { cx += (x - cx) * .18; cy += (y - cy) * .18; box.style.left = cx + "px"; box.style.top = cy + "px"; raf = requestAnimationFrame(loop); }
    $$("[data-jm-img]", list).forEach(function (row) {
      row.addEventListener("mouseenter", function () { var src = row.getAttribute("data-jm-img"); if (src) { img.src = src; box.classList.add("is-on"); } if (!raf) loop(); });
      row.addEventListener("mouseleave", function () { box.classList.remove("is-on"); });
    });
    list.addEventListener("mousemove", function (e) { x = e.clientX + 150; y = e.clientY; });
    list.addEventListener("mouseleave", function () { cancelAnimationFrame(raf); raf = null; box.classList.remove("is-on"); });
  }

  /* ------------------------------------------------------------ in-page filter chips (collection rooms) */
  function initFilter() {
    $$("[data-jm-filter-group]").forEach(function (group) {
      var grid = document.getElementById(group.getAttribute("data-jm-filter-group"));
      if (!grid) return;
      var key = group.getAttribute("data-jm-filter-key");
      var empty = document.getElementById(grid.id + "-none");
      $$("[data-jm-filter]", group).forEach(function (chip) {
        chip.addEventListener("click", function () {
          var val = chip.getAttribute("data-jm-filter");
          $$("[data-jm-filter]", group).forEach(function (c) { c.setAttribute("aria-pressed", c === chip ? "true" : "false"); });
          var shown = 0;
          $$(".jm-card", grid).forEach(function (card) {
            var ok = val === "all" || (card.getAttribute("data-" + key) || "").split(" ").indexOf(val) > -1;
            card.classList.toggle("is-hidden", !ok);
            if (ok) shown++;
          });
          if (empty) empty.hidden = shown !== 0;
        });
      });
    });
  }

  function init() { initHeader(); initSplit(); initReveals(); initCompare(); initScroll(); initStars(); initCount(); initFollow(); initFilter(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
